import { createFileRoute } from '@tanstack/react-router';
import ResetExpiredPasswordPage from '../Containers/ResetExpiredPasswordPage';
import { resetPasswordSearchSchema } from '../Utils/routeSchema';

function ResetPasswordWrapper() {
  const { token } = Route.useSearch();
  return <ResetExpiredPasswordPage token={token ?? ''} />;
}

export const Route = createFileRoute('/reset-password')({
  validateSearch: resetPasswordSearchSchema,
  component: ResetPasswordWrapper,
});
